
import { Shield, Star, MapPin, TrendingUp } from "lucide-react";

const MarketplacePreview = () => {
  const suppliers = [
    {
      name: "BuildIt Zimbabwe",
      category: "Building Materials",
      rating: 4.8,
      reviews: 324,
      verified: true,
      location: "Harare, Bulawayo",
      products: "Cement, Bricks, Steel"
    },
    {
      name: "N. Richards Group",
      category: "Construction Supplies",
      rating: 4.9,
      reviews: 156,
      verified: true,
      location: "Harare, Mutare",
      products: "Hardware, Tools, Paint"
    },
    {
      name: "Lafarge Zimbabwe",
      category: "Cement & Aggregates",
      rating: 4.7,
      reviews: 289,
      verified: true,
      location: "Nationwide",
      products: "Cement, Concrete, Sand"
    },
    {
      name: "Zimbabwe Hardware",
      category: "Local Hardware",
      rating: 4.6,
      reviews: 98,
      verified: true,
      location: "Gweru, Masvingo",
      products: "Tools, Electrical, Plumbing"
    }
  ];

  return (
    <section className="py-20 sm:py-32 bg-gradient-to-b from-green-50 via-white to-amber-50 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-green-100 text-green-800 px-4 py-2 rounded-full text-sm font-medium mb-6">
            <Shield className="w-4 h-4" />
            Verified Marketplace
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Trusted Zimbabwe Suppliers
            <span className="block bg-gradient-to-r from-green-600 to-yellow-600 bg-clip-text text-transparent">
              Verified by Real Community Activity
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Connect with vetted suppliers across Zimbabwe. Real ratings, verified prices, and community-backed recommendations.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {suppliers.map((supplier, index) => (
            <div 
              key={index}
              className="bg-white rounded-3xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-yellow-200 group cursor-pointer"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="w-12 h-12 bg-gradient-to-r from-yellow-400 to-amber-500 rounded-xl flex items-center justify-center text-white font-bold text-lg">
                  {supplier.name.charAt(0)}
                </div>
                {supplier.verified && (
                  <div className="bg-green-100 text-green-800 px-2 py-1 rounded-full text-xs font-medium flex items-center gap-1">
                    <Shield className="w-3 h-3" />
                    Verified
                  </div>
                )}
              </div>

              <h3 className="font-bold text-lg text-gray-900 mb-1 group-hover:text-yellow-600 transition-colors">
                {supplier.name}
              </h3>
              <p className="text-gray-500 text-sm mb-3">{supplier.category}</p>

              <div className="flex items-center gap-2 mb-3">
                <div className="flex items-center gap-1">
                  <Star className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                  <span className="font-semibold text-sm">{supplier.rating}</span>
                </div>
                <span className="text-gray-400 text-sm">({supplier.reviews} reviews)</span>
              </div>

              <div className="flex items-center gap-1 mb-3">
                <MapPin className="w-3 h-3 text-gray-400" />
                <span className="text-gray-500 text-xs">{supplier.location}</span>
              </div>

              <p className="text-gray-600 text-xs mb-4">{supplier.products}</p>

              <button className="w-full bg-gradient-to-r from-yellow-100 to-amber-100 text-amber-800 py-2 rounded-xl text-sm font-medium hover:from-yellow-200 hover:to-amber-200 transition-all duration-200">
                View Supplier
              </button>
            </div>
          ))}
        </div>

        {/* Stats */}
        <div className="bg-white rounded-3xl p-8 shadow-lg border border-gray-100">
          <div className="grid md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="w-16 h-16 bg-gradient-to-r from-yellow-400 to-amber-500 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <Shield className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-3xl font-bold text-gray-900 mb-2">500+</h3>
              <p className="text-gray-600">Verified Suppliers</p>
            </div>
            <div>
              <div className="w-16 h-16 bg-gradient-to-r from-green-500 to-green-600 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <TrendingUp className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-3xl font-bold text-gray-900 mb-2">5,000+</h3>
              <p className="text-gray-600">Price Verifications</p>
            </div>
            <div>
              <div className="w-16 h-16 bg-gradient-to-r from-red-500 to-red-600 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <Star className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-3xl font-bold text-gray-900 mb-2">4.8</h3>
              <p className="text-gray-600">Average Rating</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MarketplacePreview;
